// CANONICAL COPY (GH #7115). src/constants/obligations/obl-subprocessor-oversight.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-subprocessor-oversight',
  title: 'Verify ongoing sub-processor oversight and change notification',
  description:
    'Confirm that sub-processors are monitored on an ongoing basis through risk assessment, periodic meetings, inspections or third-party audit reports, and that controllers are informed in a timely manner of changes to generally approved sub-processors and of follow-up actions (GDPR Art. 28(2), Art. 28(4); FSR ISAE 3000 Kontrolmål F.3, F.6). Distinct from `obl-vendor-assessment` — this obligation captures the processor-to-controller reporting duty and the change-notification timeline specific to DPAs. Review the sub-processor oversight log, recent controller change notifications and audit-report summaries.',
  category: 'vendors',
  scfIds: ['SCF-VDR-004'],
  cadence: { frequency: '1y', anchor: 'domain' },
  // GH #6698, founder decision B. Was `strategy: 'any'`, under which a
  // published, in-SLA procedure fulfilled this obligation ON ITS OWN — and a
  // fulfilled obligation then rendered every other criterion as "Fulfilled",
  // so a tenant with an unclassified vendor register was shown a green tick
  // against the oversight actually performed.
  //
  // `manual` requires ALL criteria plus the human attestation, and yields
  // `partially-satisfied` rather than `unmet` for a tenant that has the
  // procedure but not the record — so nobody is stranded, and nobody is told
  // the record exists. This is the product's own doctrine applied where it
  // already belonged: "a published/current document is machine-checkable
  // evidence that a policy or procedure exists; it is never treated as proof
  // the underlying activity actually occurred" (`evaluateManualObligation`).
  // GDPR Art. 28(2) requires a register, not a procedure describing one.
  strategy: 'manual',
  fulfilmentCriteria: [
    {
      type: 'subprocessor-oversight-current',
      description:
        'Every processor vendor assessed within the last 12 months with assessments current',
    },
    { type: 'document-published', description: 'Sub-processor oversight procedure is published' },
    { type: 'document-within-sla', description: 'Procedure review is not overdue' },
    {
      type: 'manual-attestation',
      description:
        'Confirm sub-processors were monitored this period and that controllers were notified of any changes within the agreed timeline',
    },
  ],
  domainActions: [
    { type: 'deep-link', target: 'vendors', label: 'Review Vendors' },
    { type: 'approve-document', label: 'Approve Document' },
  ],
};
